enum SoftwareVersionStatus {
    Homologation = 0,
    Homologated = 1,
    WithProblem = 2,
    Developing = 3,
    AwaitingHomologation = 4
}

export default SoftwareVersionStatus;